import { Component, Injectable, Type } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface ModalConfig {
    withReturnValue: boolean;
    acceptLabel?: string;
    cancelLabel?: string;
    dismissLabel?: string;
    title?: string;
    customClass?: string;
    contentInputs?: Record<string, unknown>;
}
@Injectable({ providedIn: 'root' })
export class ModalDialogService {

    modalDialogEventEmitter = new Subject<{ content: Type<Component>, config?: ModalConfig }>();
    private modalDialogReturnValueEmitter: Subject<boolean>;
private readonly defaultConfig = {
        withReturnValue: false
    };

    showModalDialog(contentComponentType: Type<any>, config?: Partial<ModalConfig>): Observable<boolean> {
        this.modalDialogEventEmitter.next({ content: contentComponentType, config: { ...this.defaultConfig, ...config} });
        if (config?.withReturnValue) {
            this.modalDialogReturnValueEmitter = new Subject<boolean>();
            return this.modalDialogReturnValueEmitter;
        }
    }

    closeModalDialog(returnValue = false): void {
        this.modalDialogEventEmitter.next({ content: null });
        this.modalDialogReturnValueEmitter?.next(returnValue);
        this.modalDialogReturnValueEmitter?.complete();
        this.modalDialogReturnValueEmitter = null;
    }
}
